import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import CommonToast from "../../../../components/_utils/CommonToast";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import PrimaryStepper from "../../../../components/_utils/CommonSteppers/PrimaryStepper";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import {
  editFieldForceAccount,
  getSpecificFieldForceAccount,
  resetEditFieldForceAccount,
} from "../../../../redux/features/accounts/fieldForceAccount";

import { fieldforcerequestTxnReject } from "../../../../redux/features/fieldForceRequest";
import { FieldForceMultiTxnDeniedApproval } from "../../../../redux/features/fieldForceTransaction";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  RejectReasonLength,
  ScreenSizeConfiguration,
} from "../../../../utils/configurationProvider";
import TEXT from "../../../../utils/globalText";
import Validation from "../../../../utils/validation";
import FieldForceTxnRequestViewAll from "../../../FieldForceRequestTransactions/FieldForceTxnRequestViewAll";
import FieldForceTransactionViewAll from "../../../FieldForceTransactions/FieldForceTransactionsViewAll";
import FieldForceBankEdit from "../FieldForceBankEdit";
import FieldForceEditConfirm from "../FieldForceEditConfirm";
import "./index.css";
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint";

import {
  bankLookUp,
  verifyBankAccount,
  resetBankVerificationError,
  resetBankVerification,
  resetBankLookupData,
  getIFSCDetails,
} from "../../../../redux/features/sharedResources/sharedResources";

const FieldForceMainEditBank = () => {
  const [archivePopup, setArchivePopup] = useState(false);
  const [showRejectTnxPopup, setShowRejectTnxPopup] = useState(false);
  const [requestRejectAll, setRequestRejectAll] = useState(false);
  const [showPopupReject, setShowPopupReject] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [updateActive, setUpdateActive] = useState(false);
  const [bankLookupNext, setBankLookupNext] = useState(false);

  const [activeStep, setActiveStep] = useState(0);
  const [bankNextButtonEnabled, setBenEnableNextButton] = useState(true);

  const [isBankLinkedAccount, setIsBankLinkedAccount] = useState(false);
  const [openEditBankPop, setOpenEditBankPop] = useState(false);
  const [createNewedit, setCreateNewEdit] = useState(false);

  const [manualVirtualAccount, setManualVirtualAccount] = useState(false);
  const [isOriginalManualVirtual, setIsOriginalManualVirtual] = useState(false);
  const lastVerifyRequestRef = useRef("");
  const lastLookupAccountsRef = useRef([]);
  const [completedLookupKey, setCompletedLookupKey] = useState("");
  const [associatedNext, setAssociatedNext] = useState(false);
  const [accActiveInactiveState, setAccActiveInactiveState] =
    useState("active");
  const [currentAssociate, setCurrentAssociate] = useState(
    "Field force account",
  );
  const [showMarkVirtualSection, setShowMarkVirtualSection] = useState(
    Boolean(manualVirtualAccount),
  );
  const [virtualAccount, setVirtualAccount] = useState(false);

  const scrollIt = useRef(null);
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [payload, setPayload] = useState({
    bank_account: "",
    ifsc_code: "",
    email_id: "",
    pan_no: "",
    bank_name: "",
    contact_no: "",
    legal_name: "",
    old_bank_account: "",
    old_ifsc_code: "",
    old_name: "",
    name: "",
    gstin_detail: "",
    account_type: "",
    virtual_account: "",
    virtual_account_type: "",
    old_virtual_account_type: "",
  });

  const {
    verifyBankAccountError,
    verifyBankAccountData,
    verifyBankAccountLoading,
    bankLookupData,
    bankLookupLoading,
    bankLookupError,
    ifscDetailsLoading,
    ifscDetailsData,
    ifscDetailsError,
  } = useSelector((state) => state.sharedResources);

  const {
    editFieldForceAccountData,
    editFieldForceAccountLoading,
    editFieldForceAccountError,
    getSpecificFieldForceAccountData,
    getSpecificFieldForceAccountLoading,
  } = useSelector((state) => state.fieldForceAccount);

  const { services, isLoading } = useSelector((state) => state.refreshToken);

  const { fieldForceTxnViewAllData } = useSelector(
    (state) => state.fieldForceTransaction,
  );

  const { allFieldForceRequestTransactionsData } = useSelector(
    (state) => state.fieldForceRequest,
  );

  const fieldForceAccount =
    getSpecificFieldForceAccountData?.field_force_accounts?.[
      GlobalConfiguration.lengthCheckZero
    ];

  const handleBackBank = () => {
    if (activeStep === GlobalConfiguration.lengthCheckZero) {
      if (createNewedit) {
        setOpenEditBankPop(true);
      } else {
        navigate(
          `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
        );
      }
    } else {
      setActiveStep(
        (prevActiveStep) => prevActiveStep - GlobalConfiguration.lengthCheckOne,
      );
      if (scrollIt.current) {
        scrollIt.current.scrollLeft -= ScreenSizeConfiguration.tabviewEnd;
      }
    }
  };
  const handleUpdateBank = async () => {
    if (editFieldForceAccountLoading || isBankLinkBlocked) return;

    if (activeStep === GlobalConfiguration.lengthCheckZero) {
      handleNextBank();
    } else {
      setArchivePopup(true);
    }
  };

  const resolveUpdatedFieldForceId = (responseData) => {
    return (
      responseData?.beneficiary_accounts?.[GlobalConfiguration.lengthCheckZero]
        ?.id ||
      responseData?.beneficiary_account?.id ||
      responseData?.field_force_accounts?.[GlobalConfiguration.lengthCheckZero]
        ?.id ||
      responseData?.field_force_account?.id ||
      responseData?.account?.id ||
      responseData?.id ||
      id
    );
  };

  const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;
  const isIFSCValid =
    payload?.ifsc_code?.length === GlobalConfiguration.ifscLength &&
    ifscRegex.test(payload?.ifsc_code);

  const isBankUnchanged =
    payload?.old_bank_account === payload?.bank_account &&
    payload?.old_ifsc_code === payload?.ifsc_code;
  const hasVirtualToggleChanged =
    manualVirtualAccount !== isOriginalManualVirtual;
  const hasBankEdits = !isBankUnchanged || hasVirtualToggleChanged;

  const isAutoDetectedVirtual =
    verifyBankAccountData?.verification_details?.[
      GlobalConfiguration.lengthCheckZero
    ]?.is_virtual === "Y";

  const getLookupAccountsForCurrentBank = () => {
    const accounts =
      bankLookupData?.field_force_accounts ||
      bankLookupData?.beneficiary_accounts ||
      lastLookupAccountsRef.current ||
      [];

    return accounts.filter(
      (val) =>
        val?.bank_acc_no === payload?.bank_account &&
        val?.ifsc_code === payload?.ifsc_code,
    );
  };

  const isBankDetailsChanged =
    payload?.old_bank_account !== payload?.bank_account ||
    payload?.old_ifsc_code !== payload?.ifsc_code;

  const isBankLinkBlocked = isBankLinkedAccount;
  const isCreateStepEnabled =
    !isBankLinkBlocked && !editFieldForceAccountLoading;
  const currentBankLookupKey = `${payload?.bank_account}-${payload?.ifsc_code}`;
  const isBankLookupComplete =
    completedLookupKey === currentBankLookupKey && !bankLookupLoading;
  const isExistingManualVirtualUnchanged =
    isOriginalManualVirtual && isBankUnchanged;

  const isAutoDetectedVirtualEdit =
    virtualAccount &&
    isIFSCValid &&
    payload?.virtual_account_type === "automated";

  const isMarkVirtualVisible =
    (isExistingManualVirtualUnchanged ||
      showMarkVirtualSection ||
      manualVirtualAccount ||
      (verifyBankAccountError && isBankDetailsChanged)) &&
    !ifscDetailsError &&
    !isAutoDetectedVirtualEdit &&
    ifscDetailsData;

  console.log(isMarkVirtualVisible);

  const dataArray = [
    {
      previousText: "Cancel",
      nextText: "Next",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor: "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-primary)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextIsLoading: false,
      nextIsEnabled:
        (verifyBankAccountData?.status === true && bankLookupError === true) ||
        (isMarkVirtualVisible && verifyBankAccountError === true)
          ? verifyBankAccountLoading === false &&
            ifscDetailsLoading === false &&
            bankLookupLoading === false &&
            !bankNextButtonEnabled &&
            !isBankLinkBlocked
          : associatedNext &&
            verifyBankAccountLoading === false &&
            ifscDetailsLoading === false &&
            bankLookupLoading === false &&
            !bankNextButtonEnabled &&
            !isBankLinkBlocked,
      stepperText: "Bank details",
    },
    {
      previousText: "Previous",
      nextText: "Create",
      previousEnableBgColor: "var(--primary-nav-act)",
      nextEnableBgColor:
        verifyBankAccountLoading === false && "var(--text-primary)",
      previousHoverOption: "white",
      nextHoverOption: "black",
      previousEnableTextColor: "var(--text-primary)",
      previousDisableBgColor: "var(--text-disabled)",
      nextEnableTextColor: "var(--primary-bg)",
      nextDisableBgColor: "var(--text-disabled)",
      nextDisableTextColor: "var(--text-primary)",
      nextLoaderNeeded: true,
      nextIsLoading: editFieldForceAccountLoading,
      nextIsEnabled: isCreateStepEnabled,
      stepperText: "Confirm and create",
    },
  ];

  const handleNextBank = () => {
    if (isBankLinkBlocked) return;
    if (activeStep !== GlobalConfiguration.lengthCheckOne) {
      setActiveStep(
        (prevActiveStep) => prevActiveStep + GlobalConfiguration.lengthCheckOne,
      );
      if (scrollIt.current) {
        scrollIt.current.scrollLeft += ScreenSizeConfiguration.tabviewEnd;
      }
    }
  };

  const handleKeyDown = (event) => {
    if (
      event.key === "ArrowLeft" ||
      event.key === "ArrowRight" ||
      event.key === " "
    ) {
      event.preventDefault();
    }
  };

  const isBankInputValid =
    payload?.bank_account?.length >= GlobalConfiguration.accountnormalLength &&
    payload?.ifsc_code?.length === GlobalConfiguration.ifscLength &&
    /^[A-Z]{4}0[A-Z0-9]{6}$/.test(payload.ifsc_code);

  const isExistingManualVirtual =
    payload?.virtual_account === "Y" &&
    payload?.virtual_account_type === "manual";
  const shouldSkipBankVerification =
    manualVirtualAccount || (isExistingManualVirtual && isBankUnchanged);

  const resetVerifyRequestRef = () => {
    lastVerifyRequestRef.current = "";
  };

  const createBankAccount = async () => {
    setArchivePopup(false);
    if (updateActive) return;

    if (fieldForceAccount?.pending_field_force_transactions === "Y") {
      setShowRejectTnxPopup(true);
      return;
    }

    if (fieldForceAccount?.pending_field_force_requests === "Y") {
      setRequestRejectAll(true);
      return;
    }

    await proceedWithBankEdit();
  };

  const proceedWithBankEdit = async () => {
    if (updateActive) return;
    setUpdateActive(true);

    try {
      await dispatch(
        editFieldForceAccount({
          id: id,
          bank_account_no: payload.bank_account,
          ifsc: payload.ifsc_code,
          name: payload?.name || payload?.legal_name,
          virtual: manualVirtualAccount,
          navigate,
        }),
      ).unwrap();
    } catch (error) {
      console.error("Error occurred while editing field force account:", error);
    } finally {
      setUpdateActive(false);
    }
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");
    const limitedValue = sanitizedValue.slice(
      GlobalConfiguration.lengthCheckZero,
      RejectReasonLength.lengthOfDecline,
    );
    setDeclineReason(limitedValue);
  };

  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;
    if (length === 0) return "default";
    if (length >= GlobalConfiguration.rejectReasonMinLength) return "verified";
    return focused ? "typing" : "error";
  };

  const closePendingRejectPopups = () => {
    setShowRejectTnxPopup(false);
    setRequestRejectAll(false);
    setShowPopupReject(false);
    setDeclineReason("");
    setShowLoader(false);
  };

  const handleRejectAllTransaction = async () => {
    if (showLoader) return;
    setShowLoader(true);
    setShowPopupReject(false);

    const AccountIdData = declineReason;
    let linkedTxnIds = [];

    if (
      fieldForceTxnViewAllData?.transactions?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      linkedTxnIds = fieldForceTxnViewAllData.transactions.map(
        (tx) => tx?.txn_id,
      );
    }

    UniversalRefreshToast("Rejecting transactions.");

    let txnResponse = null;
    if (linkedTxnIds.length > GlobalConfiguration.lengthCheckZero) {
      txnResponse = await dispatch(
        FieldForceMultiTxnDeniedApproval({
          id: linkedTxnIds,
          AccountIdData,
        }),
      );
    }

    if (
      txnResponse?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "AFieldForceTxn" },
      });
      setShowLoader(false);
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalLarge),
    );

    if (
      txnResponse?.payload?.status === false &&
      linkedTxnIds.length > GlobalConfiguration.lengthCheckZero
    ) {
      const errorMsg =
        txnResponse?.payload?.errors?.base?.[0] ||
        "Failed to batch reject field force transactions.";
      CommonToast({
        text: errorMsg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setShowLoader(false);
      return;
    }

    CommonToast({
      text: "Associated transactions rejected successfully.",
      icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
      variant: "var(--success)",
      buttonNeeded: false,
    });

    setShowRejectTnxPopup(false);

    if (fieldForceAccount?.pending_field_force_requests === "Y") {
      setRequestRejectAll(true);
      setShowLoader(false);
      return;
    }

    setDeclineReason("");
    await dispatch(getSpecificFieldForceAccount({ id }));
    await proceedWithBankEdit();
    setShowLoader(false);
  };

  const handleRejectRequestTxn = async () => {
    if (showLoader) return;
    setShowLoader(true);
    setShowPopupReject(false);

    const AccountIdData = declineReason;
    const requestIds =
      allFieldForceRequestTransactionsData?.requests?.length >
      GlobalConfiguration.lengthCheckZero
        ? allFieldForceRequestTransactionsData.requests.map(
            (data) => data?.request_id,
          )
        : [];

    UniversalRefreshToast("Rejecting requests");

    let data = null;
    if (requestIds.length > GlobalConfiguration.lengthCheckZero) {
      data = await dispatch(
        fieldforcerequestTxnReject({
          request_ids: requestIds,
          AccountIdData,
        }),
      );
    } else {
      setShowLoader(false);
      return;
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "AFieldForceRequest" },
      });
      setShowLoader(false);
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration.intervalLarge),
    );

    if (data?.payload?.status === false || data?.payload === undefined) {
      const errorMsg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

      CommonToast({
        text: errorMsg,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setShowLoader(false);
      return;
    }

    CommonToast({
      text: "Requests rejected successfully.",
      icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
      variant: "var(--success)",
      buttonNeeded: false,
    });

    setRequestRejectAll(false);
    setDeclineReason("");
    await dispatch(getSpecificFieldForceAccount({ id }));
    await proceedWithBankEdit();
    setShowLoader(false);
  };
  const handleConfirm = () => {
    navigate(
      `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/${id}`,
    );
  };
  useEffect(() => {
    const fetchBankData = async () => {
      let response = await dispatch(getSpecificFieldForceAccount({ id: id }));
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    };
    fetchBankData();
  }, [dispatch, id, navigate]);

  useEffect(() => {
    if (
      !getSpecificFieldForceAccountLoading &&
      getSpecificFieldForceAccountData?.status === true
    ) {
      const fieldForceAccount =
        getSpecificFieldForceAccountData?.field_force_accounts?.[
          GlobalConfiguration.lengthCheckZero
        ];

      const isManualVirtualAccount =
        fieldForceAccount?.virtual_account === "Y" &&
        fieldForceAccount?.virtual_account_type === "manual";

      setPayload({
        ...payload,
        name: fieldForceAccount?.name,
        bank_account: fieldForceAccount?.bank_acc_no,
        ifsc_code: fieldForceAccount?.ifsc_code,
        bank_name: fieldForceAccount?.bank_name,
        pan_no: fieldForceAccount?.pan_no,
        email_id: fieldForceAccount?.email_id,
        contact_no: fieldForceAccount?.contact_no,
        legal_name: fieldForceAccount?.pan_legal_name,
        old_bank_account: fieldForceAccount?.bank_acc_no,
        old_ifsc_code: fieldForceAccount?.ifsc_code,
        old_name: fieldForceAccount?.name,
        old_virtual_account_type: fieldForceAccount?.virtual_account_type,
        gstin_detail: fieldForceAccount?.gstin_detail,
        account_type: fieldForceAccount?.account_type,
        virtual_account: fieldForceAccount?.virtual_account,
        virtual_account_type: fieldForceAccount?.virtual_account_type,
        virtual: isManualVirtualAccount ? true : "",
        skip_account_verification: isManualVirtualAccount ? "Y" : "N",
      });
    }
  }, [
    getSpecificFieldForceAccountData,
    getSpecificFieldForceAccountLoading,
    dispatch,
  ]);

  useEffect(() => {
    if (editFieldForceAccountData?.status === true) {
      const updatedAccountId = resolveUpdatedFieldForceId(
        editFieldForceAccountData,
      );
      const currentName = payload?.name || payload?.legal_name;
      const updatedFields = [];

      const hasBankAccountChange =
        payload.bank_account !== payload.old_bank_account;
      const hasIfscChange = payload.ifsc_code !== payload.old_ifsc_code;
      const isCurrentlyVirtual =
        manualVirtualAccount ||
        payload?.virtual_account === "Y" ||
        payload?.virtual === true;
      const resolvedVirtualType = manualVirtualAccount
        ? "manual"
        : payload?.virtual_account_type;
      const hasVirtualTypeChange =
        resolvedVirtualType !== payload?.old_virtual_account_type;

      if (hasBankAccountChange || hasIfscChange) {
        updatedFields.push("bank_acc_no");
        updatedFields.push("ifsc_code");
      }
      if (currentName !== payload?.old_name) {
        updatedFields.push("bank_account_holder_name");
      }
      if (
        hasVirtualTypeChange ||
        manualVirtualAccount !== isOriginalManualVirtual ||
        (isCurrentlyVirtual && (hasBankAccountChange || hasIfscChange))
      ) {
        updatedFields.push("virtual_account_type");
      }

      const updatedPreview = {
        ...(updatedFields.includes("bank_acc_no")
          ? { bank_acc_no: payload.bank_account }
          : {}),
        ...(updatedFields.includes("ifsc_code")
          ? { ifsc_code: payload.ifsc_code }
          : {}),
        ...(updatedFields.includes("bank_account_holder_name")
          ? { bank_account_holder_name: currentName }
          : {}),
        ...(updatedFields.includes("virtual_account_type")
          ? {
              virtual_account: isCurrentlyVirtual
                ? "Y"
                : payload?.virtual_account,
              virtual_account_type: resolvedVirtualType,
            }
          : {}),
        pan_no: payload.pan_no,
      };

      navigate(
        `/field_force_account_dashboard/field_force_account_view_all/field_force_account_detail_page/edit_bank_details_success/${updatedAccountId}`,
        {
          state: {
            updatedAccountId,
            updatedFields,
            updatedPreview,
          },
          replace: true,
        },
      );
      dispatch(resetEditFieldForceAccount());
    } else if (
      !editFieldForceAccountLoading &&
      editFieldForceAccountData?.status === false
    ) {
      CommonToast({
        text: Object.values(editFieldForceAccountData?.errors)[
          GlobalConfiguration.lengthCheckZero
        ][GlobalConfiguration.lengthCheckZero],
        icon: ICONS?.INFO_FILLED,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  }, [editFieldForceAccountData, editFieldForceAccountLoading]);

  useEffect(() => {
    if (!editFieldForceAccountError) return;
  }, [editFieldForceAccountError]);

  useEffect(() => {
    const accounts =
      bankLookupData?.field_force_accounts ||
      bankLookupData?.beneficiary_accounts;
    if (accounts?.length) {
      lastLookupAccountsRef.current = accounts;
    }
  }, [bankLookupData]);

  useEffect(() => {
    lastLookupAccountsRef.current = [];
    setCompletedLookupKey("");
  }, [payload?.bank_account, payload?.ifsc_code]);

  useEffect(() => {
    if (
      !bankLookupLoading &&
      payload?.bank_account &&
      payload?.ifsc_code &&
      (bankLookupData || bankLookupError)
    ) {
      setCompletedLookupKey(`${payload.bank_account}-${payload.ifsc_code}`);
    }
  }, [
    bankLookupLoading,
    bankLookupData,
    bankLookupError,
    payload?.bank_account,
    payload?.ifsc_code,
  ]);
  useEffect(() => {
    if (activeStep === GlobalConfiguration.lengthCheckOne) {
      return;
    }

    if (manualVirtualAccount) {
      if (!hasBankEdits) {
        setBenEnableNextButton(true);
        return;
      }
      if (
        isIFSCValid &&
        payload?.bank_account?.length >= GlobalConfiguration.accountnormalLength
      ) {
        setBenEnableNextButton(false);
        return;
      }
      setBenEnableNextButton(true);
      return;
    }

    if (verifyBankAccountError) {
      setBenEnableNextButton(true);
      return;
    }

    const lookupAccounts = getLookupAccountsForCurrentBank();
    const hasJointAssociatedAccounts =
      lookupAccounts.length > GlobalConfiguration.lengthCheckZero;

    const currentBankKey = `${payload?.bank_account}-${payload?.ifsc_code}`;
    const isLookupCompleteForCurrentBank =
      completedLookupKey === currentBankKey && !bankLookupLoading;
    const needsLookupBeforeNext =
      isBankDetailsChanged &&
      !manualVirtualAccount &&
      !isAutoDetectedVirtual &&
      verifyBankAccountData?.status === true &&
      !verifyBankAccountLoading &&
      payload?.ifsc_code?.length === GlobalConfiguration.ifscLength &&
      isIFSCValid &&
      payload?.bank_account?.length >= GlobalConfiguration.accountnormalLength;

    if (needsLookupBeforeNext && !isLookupCompleteForCurrentBank) {
      setBenEnableNextButton(true);
      return;
    }

    const isBankAlreadyLinkedToPan =
      payload?.bank_account?.length >=
        GlobalConfiguration.accountnormalLength &&
      lookupAccounts?.some(
        (val) =>
          payload?.pan_no === val?.pan_no &&
          payload?.bank_account === val?.bank_acc_no &&
          payload?.bank_account !== payload?.old_bank_account,
      );

    setIsBankLinkedAccount(isBankAlreadyLinkedToPan);

    let foundAccount = lookupAccounts?.find(
      (val) =>
        payload?.pan_no === val?.pan_no &&
        payload?.bank_account === val?.bank_acc_no &&
        payload?.bank_account !== payload?.old_bank_account,
    );

    if (isBankAlreadyLinkedToPan) {
      if (isBankAlreadyLinkedToPan) {
        setCurrentAssociate(
          foundAccount?.type_of_account === "field_force"
            ? "Field force account"
            : foundAccount?.type_of_account === "reimbursement"
              ? "Reimbursement account"
              : foundAccount?.type_of_account === "tds"
                ? "Tax account"
                : "Beneficiary account",
        );
        setAccActiveInactiveState(
          foundAccount?.approval_status === "rejected" ||
            foundAccount?.approval_status === "blocked" ||
            foundAccount?.approval_status === "archived"
            ? "inactive"
            : "active",
        );
      }
      setBenEnableNextButton(true);
      return;
    }

    if (
      payload?.ifsc_code?.length < GlobalConfiguration.ifscLength ||
      !isIFSCValid ||
      payload?.bank_account?.length < GlobalConfiguration.accountnormalLength
    ) {
      setBenEnableNextButton(true);
      return;
    }

    if (
      hasJointAssociatedAccounts &&
      isBankDetailsChanged &&
      verifyBankAccountData?.status === true &&
      !verifyBankAccountLoading &&
      !isAutoDetectedVirtual &&
      isLookupCompleteForCurrentBank
    ) {
      setBenEnableNextButton(false);
      return;
    }

    if (!verifyBankAccountLoading) {
      lookupAccounts?.forEach((val) => {
        if (
          payload?.old_bank_account === val?.bank_acc_no &&
          payload?.old_ifsc_code === val?.ifsc_code
        ) {
          setBenEnableNextButton(true);
        }
      });

      if (
        payload?.old_bank_account === payload?.bank_account &&
        payload?.old_ifsc_code === payload?.ifsc_code
      ) {
        setBenEnableNextButton(true);
      } else {
        const bankErrors = Validation.validateBankAcc(
          "bank_account",
          payload?.bank_account,
          {},
        );
        const ifscErrors = Validation.validateIfsc(
          "ifsc_code",
          payload?.ifsc_code,
          {},
        );
        const isLocallyValid =
          !bankErrors?.bank_account && !ifscErrors?.ifsc_code;

        if (
          isLocallyValid &&
          verifyBankAccountData?.status === true &&
          !verifyBankAccountError &&
          !verifyBankAccountLoading &&
          (!needsLookupBeforeNext || isLookupCompleteForCurrentBank)
        ) {
          setBenEnableNextButton(false);
        } else {
          setBenEnableNextButton(true);
        }
      }
    }
  }, [
    bankLookupData,
    payload,
    verifyBankAccountLoading,
    bankLookupLoading,
    isIFSCValid,
    activeStep,
    manualVirtualAccount,
    verifyBankAccountError,
    verifyBankAccountData,
    hasBankEdits,
    isOriginalManualVirtual,
    isAutoDetectedVirtual,
    completedLookupKey,
  ]);

  useEffect(() => {
    if (activeStep === GlobalConfiguration.lengthCheckOne) {
      return;
    }
    if (manualVirtualAccount || verifyBankAccountError) {
      return;
    }

    if (
      verifyBankAccountData?.status &&
      !verifyBankAccountLoading &&
      verifyBankAccountData?.verification_details[0]?.virtual_account_type ===
        "manual"
    ) {
      setManualVirtualAccount(true);
      setIsOriginalManualVirtual(true);
      dispatch(resetBankVerificationError());
      dispatch(resetBankVerification());
      lastVerifyRequestRef.current = `${fieldForceAccount?.bank_acc_no}-${fieldForceAccount?.ifsc_code}-${fieldForceAccount?.pan_legal_name}`;
    }

    if (
      !verifyBankAccountLoading &&
      verifyBankAccountData?.status === true &&
      isIFSCValid &&
      isAutoDetectedVirtual &&
      hasBankEdits
    ) {
      const bankErrors = Validation.validateBankAcc(
        "bank_account",
        payload?.bank_account,
        {},
      );
      const ifscErrors = Validation.validateIfsc(
        "ifsc_code",
        payload?.ifsc_code,
        {},
      );
      if (!bankErrors?.bank_account && !ifscErrors?.ifsc_code) {
        setBenEnableNextButton(false);
      }
    }
  }, [
    activeStep,
    manualVirtualAccount,
    verifyBankAccountError,
    verifyBankAccountLoading,
    verifyBankAccountData?.status,
    verifyBankAccountData?.verification_details,
    isIFSCValid,
    isAutoDetectedVirtual,
    hasBankEdits,
    payload?.bank_account,
    payload?.ifsc_code,
  ]);

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("FFUAccount") || services?.includes("Admin")) {
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "FFUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
  useEffect(() => {
    if (manualVirtualAccount) {
      dispatch(resetBankVerificationError());
    }
  }, [manualVirtualAccount, dispatch]);

  useEffect(() => {
    if (verifyBankAccountData?.status === true && isBankInputValid) {
      dispatch(
        bankLookUp({
          ifsc: payload.ifsc_code,
          bank_account_no: payload.bank_account,
        }),
      );
    }
  }, [
    verifyBankAccountData,
    manualVirtualAccount,
    isBankInputValid,
    dispatch,
    payload.ifsc_code,
    payload.bank_account,
  ]);

  useEffect(() => {
    if (!payload?.bank_account && payload?.ifsc_code) {
      const newObj = { ...payload, ifsc_code: "" };
      setPayload(newObj);
      setBenEnableNextButton(true);
      setIsBankLinkedAccount(false);
    }
    if (
      payload?.bank_account?.length < GlobalConfiguration.accountnormalLength
    ) {
      const obj = { ...payload, ifsc_code: "" };
      setPayload(obj);
    }
    if (isBankInputValid) {
      if (services?.includes("FFUAccount") || services?.includes("Admin")) {
        dispatch(resetBankVerificationError());
        dispatch(
          verifyBankAccount({
            ifsc_code: payload?.ifsc_code,
            bank_account: payload?.bank_account,
            legal_name: payload?.legal_name,
            navigate: navigate,
          }),
        );
        dispatch(
          getIFSCDetails({
            search_string: payload?.ifsc_code,
            page_no: GlobalConfiguration?.lengthCheckOne,
            page_size: GlobalConfiguration?.filterResults,
          }),
        );
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "FFUAccount" },
        });
      }
    } else {
      lastVerifyRequestRef.current = "";
      dispatch(resetBankVerification());
      dispatch(resetBankLookupData());
    }
  }, [
    dispatch,
    isBankInputValid,
    navigate,
    payload?.ifsc_code,
    payload?.bank_account,
    payload?.legal_name,
    services,
    shouldSkipBankVerification,
  ]);

  return (
    <div
      className="edit_bank_con_main !h-screen"
      style={{
        overflowY:
          openEditBankPop ||
          showRejectTnxPopup ||
          requestRejectAll ||
          archivePopup ||
          showPopupReject
            ? "hidden"
            : "hidden",
        height:
          openEditBankPop ||
          showRejectTnxPopup ||
          requestRejectAll ||
          archivePopup ||
          showPopupReject
            ? "var(--full-height)"
            : "",
      }}
    >
      <div className="hidden Qsmd:block min-h-navbar-breadcrumb-height"></div>
      {openEditBankPop && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopup
            headerTitle={"Confirm leaving this page?"}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            subtext="Leaving this page will not update the changes made."
            btnOneText="Stay"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setOpenEditBankPop(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Leave"
            btnTwoBtnType="button"
            btnTwoHandleFunction={handleConfirm}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      {showRejectTnxPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-custom-backdrop bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle="Associated transactions found"
            headersubtext="The following transactions are linked and need to be rejected before archiving this account."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={closePendingRejectPopups}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText='To archive the account, please reject the transactions listed above by clicking the "Reject all" button. The transactions will get rejected with the provided rejected reason.'
            isbottomSectionneed={true}
            btnText={"Reject all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              const hasAccess = services?.find(
                (service) =>
                  service === "AFieldForceTxn" || service === "Admin",
              );
              if (!hasAccess) return;
              setShowPopupReject(true);
            }}
            isLoaderNeeded={true}
            isLoading={showLoader}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            inActiveVariantNeeded
            isDisabled={
              services?.find((service) => service === "AFieldForceTxn") ===
              undefined
            }
            disabledTextColor={"var(--text-primary)"}
            disabledBgColor={"var(--text-disabled)"}
          >
            <FieldForceTransactionViewAll
              TxnHistoryid={id}
              bene_account_id={id}
              typepop={"reimburse_txnViewAll_popup_reject"}
              flowType={"decline account details"}
              closeRejectAllTxn={closePendingRejectPopups}
              bene_account_name={fieldForceAccount?.name}
              handleRejectAllTransaction={handleRejectAllTransaction}
              type={"bene_account_detail_modal"}
              setShowLoader={setShowLoader}
              setSidebarState={() => {}}
              setShowScheduleTxnPopup={() => {}}
              showLoader={showLoader}
              setFocus={() => {}}
              isPopupMode={true}
            />
          </LargePopupRedirect>
        </div>
      )}

      {requestRejectAll && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle="Pending requests found"
            headersubtext="The following requests are linked and need to be rejected before archiving this account."
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            headertextSize="font-md"
            closeiconbtnType="button"
            closeiconhandleFunction={closePendingRejectPopups}
            closeiconisDisabled={false}
            closeiconenabledBgColor="var(--primary-nav)"
            closeicondisabledBgColor="var(--text-disabled)"
            closeiconhoverOption="white"
            closeicon={ICONS?.CLOSE}
            bottomHeaderTextNeed={true}
            bottomHeaderText='To archive this account, please reject the requests listed above by clicking the "Reject all" button. The requests will get rejected with the provided rejected reason.'
            isbottomSectionneed={true}
            btnText={"Reject all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              const hasAccess = services?.find(
                (service) =>
                  service === "AFieldForceRequest" || service === "Admin",
              );
              if (!hasAccess) return;
              if (declineReason && declineReason.trim().length > 0) {
                handleRejectRequestTxn();
              } else {
                setShowPopupReject(true);
              }
            }}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            isLoaderNeeded={true}
            isLoading={showLoader}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            inActiveVariantNeeded
            isDisabled={
              services?.find((service) => service === "AFieldForceRequest") ===
              undefined
            }
            disabledTextColor={"var(--text-primary)"}
            disabledBgColor={"var(--text-disabled)"}
          >
            <FieldForceTxnRequestViewAll
              TxnHistoryid={fieldForceAccount?.id}
              TxnHistoryAccountName={fieldForceAccount?.name}
              typepop="requestViewallPopup"
              flowType="RequestRejectAll"
              closeRejectAllTxn={closePendingRejectPopups}
              setShowLoader={setShowLoader}
              showLoader={showLoader}
              type="requestViewallPopup"
              isPopupMode={true}
            />
          </LargePopupRedirect>
        </div>
      )}

      {showPopupReject && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Please state the reason for rejecting the transaction."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteColor="text-secondary"
            inputPlaceholder={TEXT.REASON_10_150_CHAR}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={() => setIsFocused(true)}
            inputOnBlur={() => setIsFocused(false)}
            inputIsDisabled={showLoader}
            btnOneIsDisabled={showLoader}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              if (!showLoader) {
                closePendingRejectPopups();
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              if (showRejectTnxPopup) {
                handleRejectAllTransaction();
              } else if (requestRejectAll) {
                handleRejectRequestTxn();
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length < GlobalConfiguration.rejectReasonMinLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoInActiveVariantNeeded={true}
            btnTwoIsLoaderNeeded={showLoader}
            btnTwoIsLoading={showLoader}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      {showRejectTnxPopup && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-custom-backdrop bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle="Associated transactions found"
            headersubtext="The following transactions are linked and need to be rejected before archiving this account."
            closeiconenabledBgColor="var(--primary-nav)"
            closeiconisLoading={false}
            closeiconhandleFunction={closePendingRejectPopups}
            closeicon={ICONS?.CLOSE}
            closeiconhoverOption="white"
            closeiconbtnType={"button"}
            closeiconisDisabled={false}
            closeicondisabledBgColor={""}
            closeiconbuttonRef={null}
            closeicontitle={"Close"}
            btnType={"button"}
            bottomHeaderTextNeed={true}
            bottomHeaderText='To archive the account, please reject the transactions listed above by clicking the "Reject all" button. The transactions will get rejected with the provided rejected reason.'
            isbottomSectionneed={true}
            btnText={"Reject all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              const hasAccess = services?.find(
                (service) =>
                  service === "AFieldForceTxn" || service === "Admin",
              );
              if (!hasAccess) return;
              setShowPopupReject(true);
            }}
            isLoaderNeeded={true}
            isLoading={showLoader}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            fullWidthRequired={false}
            inActiveVariantNeeded
            isDisabled={
              services?.find((service) => service === "AFieldForceTxn") ===
              undefined
            }
            disabledTextColor={"var(--text-primary)"}
            disabledBgColor={"var(--text-disabled)"}
          >
            <FieldForceTransactionViewAll
              TxnHistoryid={id}
              bene_account_id={id}
              typepop={"reimburse_txnViewAll_popup_reject"}
              flowType={"decline account details"}
              closeRejectAllTxn={closePendingRejectPopups}
              bene_account_name={fieldForceAccount?.name}
              handleRejectAllTransaction={handleRejectAllTransaction}
              type={"bene_account_detail_modal"}
              setShowLoader={setShowLoader}
              setSidebarState={() => {}}
              setShowScheduleTxnPopup={() => {}}
              showLoader={showLoader}
              setFocus={() => {}}
              isPopupMode={true}
            />
          </LargePopupRedirect>
        </div>
      )}

      {requestRejectAll && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <LargePopupRedirect
            headerTitle="Pending requests found"
            headersubtext="The following requests are linked and need to be rejected before archiving this account."
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            headertextSize="font-md"
            closeiconbtnType="button"
            closeiconhandleFunction={closePendingRejectPopups}
            closeiconisDisabled={false}
            closeiconenabledBgColor="var(--primary-nav)"
            closeicondisabledBgColor="var(--text-disabled)"
            closeiconhoverOption="white"
            closeicon={ICONS?.CLOSE}
            bottomHeaderTextNeed={true}
            bottomHeaderText='To archive this account, please reject the requests listed above by clicking the "Reject all" button. The requests will get rejected with the provided rejected reason.'
            isbottomSectionneed={true}
            btnText={"Reject all"}
            confirmbtnrequired={true}
            handleFunction={() => {
              const hasAccess = services?.find(
                (service) =>
                  service === "AFieldForceRequest" || service === "Admin",
              );
              if (!hasAccess) return;
              if (declineReason && declineReason.trim().length > 0) {
                handleRejectRequestTxn();
              } else {
                setShowPopupReject(true);
              }
            }}
            enabledBgColor={"var(--negative-act)"}
            hoverOption={"dark"}
            isLoaderNeeded={true}
            isLoading={showLoader}
            outLineColor={""}
            enabledTextColor={"var(--text-primary)"}
            inActiveVariantNeeded
            isDisabled={
              services?.find((service) => service === "AFieldForceRequest") ===
              undefined
            }
            disabledTextColor={"var(--text-primary)"}
            disabledBgColor={"var(--text-disabled)"}
          >
            <FieldForceTxnRequestViewAll
              TxnHistoryid={fieldForceAccount?.id}
              TxnHistoryAccountName={fieldForceAccount?.name}
              typepop="requestViewallPopup"
              flowType="RequestRejectAll"
              closeRejectAllTxn={closePendingRejectPopups}
              setShowLoader={setShowLoader}
              showLoader={showLoader}
              type="requestViewallPopup"
              isPopupMode={true}
            />
          </LargePopupRedirect>
        </div>
      )}

      {showPopupReject && (
        <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
          <SmallPopupWithInput
            headerTitle="Rejected reason"
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            secondHeaderTitle="Please state the reason for rejecting the account."
            secondHeaderFontWeight="normal"
            secondHeaderFontColor="text-secondary"
            secondHeaderTextSize="font-xs"
            noteColor="text-secondary"
            inputPlaceholder={TEXT.REASON_10_150_CHAR}
            inputVariant={computeVariant(declineReason, isFocused)}
            inputOnFocus={() => setIsFocused(true)}
            inputOnBlur={() => setIsFocused(false)}
            inputIsDisabled={showLoader}
            btnOneIsDisabled={showLoader}
            inputBgColor="var(--primary-bg)"
            inputFgColor="var(--text-secondary)"
            inputOnInput={(e) => {
              if (!showLoader) {
                handleInputChange(e);
              }
            }}
            inputValue={declineReason}
            inputFontKind="small"
            inputIsFullWidth={true}
            btnOneText="Cancel"
            btnOneHandleFunction={() => {
              if (!showLoader) {
                closePendingRejectPopups();
              }
            }}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnTwoText="Reject"
            btnTwoHandleFunction={() => {
              if (showRejectTnxPopup) {
                handleRejectAllTransaction();
              } else if (requestRejectAll) {
                handleRejectRequestTxn();
              }
            }}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={
              !declineReason ||
              declineReason.length < GlobalConfiguration.rejectReasonMinLength
            }
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoInActiveVariantNeeded={true}
            btnTwoIsLoaderNeeded={showLoader}
            btnTwoIsLoading={showLoader}
            btnTwoHoverOption="black"
          />
        </div>
      )}

      {archivePopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <SmallPopupWithBulletPoints
            headerTitle={"Account update"}
            headerFontWeight="semibold"
            headerFontColor="text-primary"
            textSize="font-md"
            bulletPoints={[
              "The old account will be archived and become inactive.",
              "The new account will be created as an active beneficiary account.",
              "Inactive accounts cannot be used to create transactions.",
            ]}
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setArchivePopup(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Proceed"
            btnTwoBtnType="button"
            btnTwoIsLoaderNeeded
            btnTwoIsLoading={updateActive}
            btnTwoHandleFunction={createBankAccount}
            btnTwoEnabledBgColor="var(--positive-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div className="main_edit_stepper_div z-z-index-header">
        <div className="w-full Qsmd:w-std-width relative min-h-stepper-height Qsmd:top-top-base top-[calc(-1*var(--padding-sm))]">
          <PrimaryStepper
            activeStep={activeStep}
            handleForwardAction={handleUpdateBank}
            handleBackwardAction={handleBackBank}
            dataArray={dataArray}
          />
        </div>
      </div>

      <div className="top_bar_btn_resp_edit Qsmd:hidden flex">
        <TopNavComponent
          isFormattingNotRequired
          topNavHeader={"Field force account"}
          topNavSubText="Bank details"
          handleBack={handleBackBank}
        />
      </div>
      <div
        className="edit_bank_details_all no-scrollbar Qsmd:pt-padding-lg pt-stepper-gap-between pb-padding-md Qsmd:pb-padding-base mt-margin-sm Qsmd:mt-margin-base flex-col px-padding-md Qlg:px-padding-base"
        ref={scrollIt}
      >
        {activeStep === 0 ? (
          <FieldForceBankEdit
            setBankLookupNext={setBankLookupNext}
            bankLookupNext={bankLookupNext}
            setBenEnableNextButton={setBenEnableNextButton}
            payload={payload}
            setPayload={setPayload}
            activeStep={activeStep}
            setAssociatedNext={setAssociatedNext}
            setCreateNewEdit={setCreateNewEdit}
            benebankLookData={bankLookupData}
            isIFSCValid={isIFSCValid}
            isBankLinkedAccount={isBankLinkedAccount}
            accActiveInactiveState={accActiveInactiveState}
            setAccActiveInactiveState={setAccActiveInactiveState}
            currentAssociate={currentAssociate}
            setCurrentAssociate={setCurrentAssociate}
            id={id}
            manualVirtualAccount={manualVirtualAccount}
            setManualVirtualAccount={setManualVirtualAccount}
            isOriginalManualVirtual={isOriginalManualVirtual}
            resetVerifyRequestRef={resetVerifyRequestRef}
            isBankLookupComplete={isBankLookupComplete}
            getSpecificFieldForceAccountLoading={
              getSpecificFieldForceAccountLoading
            }
            associatedNext={associatedNext}
            setShowMarkVirtualSection={setShowMarkVirtualSection}
            isMarkVirtualVisible={isMarkVirtualVisible}
            virtualAccount={virtualAccount}
            setVirtualAccount={setVirtualAccount}
          />
        ) : (
          <FieldForceEditConfirm
            activeStep={activeStep}
            setActiveStep={setActiveStep}
            payload={payload}
          />
        )}
        <div className="h-px py-padding-sm"></div>
      </div>
      <div className="Qsmd:hidden block min-h-pagination-height"></div>
    </div>
  );
};

export default FieldForceMainEditBank;
